interface IRandomInteger {
  min?: number;
  max: number;
}

export function randomInteger({ min = 0, max }: IRandomInteger) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
